
define(['mbmustache', 'underscore'], function (Mustache, _) {
  /**
   * @deprecated The versoin of 0.7.2 Will be deleted in next few releases.
   */
  function iAmDeprecated() {
    console.warn("Mustache will be removed in future releases. Please include mustache from a CDN or your local files.");
  }

  var mewMustache = _.extend({}, Mustache);

  var originalToHtml = mewMustache.to_html,
  originalRender = mewMustache.render;
  
  mewMustache.to_html = function() {
    iAmDeprecated();
    return originalToHtml.apply(this, arguments);
  }

  mewMustache.render = function() {
    iAmDeprecated();
    return originalRender.apply(this, arguments);
  }

  return mewMustache;
});
